import { render, staticRenderFns } from "./VerifyCertificate.vue?vue&type=template&id=6bc40eab&scoped=true"
import script from "./VerifyCertificate.vue?vue&type=script&lang=ts"
export * from "./VerifyCertificate.vue?vue&type=script&lang=ts"
import style0 from "./VerifyCertificate.vue?vue&type=style&index=0&id=6bc40eab&prod&lang=scss&scoped=true"
import style1 from "./VerifyCertificate.vue?vue&type=style&index=1&id=6bc40eab&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc40eab",
  null
  
)

export default component.exports